import React, { useState } from 'react';
import styled from 'styled-components';

import { SideMenuStyle as Wrapper } from './Detail';
import BestFlag from '../../../components/UI/BestFlag';
import Counter from '../../../components/UI/Counter';

import { BG, FONT } from '../../../styles/color';
import Buttons from '../../../components/UI/Buttons';
import { cartApi } from '../../../api/cart';
import { useNavigate } from 'react-router-dom';
import { SHIPPING_FEE } from '../../../utils/constants';
import { useSelector } from 'react-redux';

const Text = styled.p`
	margin: 0;
	padding: 0;
	font-family: Pretendard Variable;
	font-weight: 500;
	font-size: ${(props) => props.size};
	color: ${(props) => ((props.color) ? props.color : FONT.default)};
`;

const BoldText = styled.p`
	margin: 0;
	padding: 0;
	font-family: Pretendard Variable;
	font-weight: 750;
	font-size: ${(props) => props.size};
	color: ${(props) => ((props.color) ? props.color : FONT.default)};
`;

const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 15px;
`;

const Price = styled.div`
	margin-top: 40px;
`;

const ExtraInfo = styled.div`
	display: grid;
	grid-template-columns: 90px 1fr;
	row-gap: 10px;
`;

const TotalPriceWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

const CounterWrapper = styled.div`
	display: flex;
	height: 75px;
	padding: 0 15px;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	background-color: ${ BG.light02 };
`;

export default function SideMenu(props) {
	const [formData, setFormData] = useState({
		productCode: props.productCode,
		quantity: 1
	});

	const navigate = useNavigate();

	const onCountUp = () => {
		setFormData({
			...formData,
			quantity: formData.quantity + 1
		});
	};

	const onCountDown = () => {
		setFormData({
			...formData,
			quantity: formData.quantity - 1
		});
	};

	const setCountAs = (value) => {
		setFormData({
			...formData,
			quantity: value
		});
	};

	const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

	const onClickAddToCart = () => {
		if(isAuthenticated === false) {
			alert('로그인이 필요한 서비스입니다.');
			navigate('/log-in');
			return;
		}

		cartApi.addToCart(formData)
			.then(response => {
				navigate('/shopping-cart');
			})
			.catch(error => {
				alert('장바구니 추가에 실패했습니다. 다시 시도해주세요.');
			}
		);
	};

	const onClickBuyNow = () => {
		if(isAuthenticated === false) {
			alert('로그인이 필요한 서비스입니다.');
			navigate('/log-in');
			return;
		}

		const orderData = {
			productCode: data.productCode,
		    productName: data.productName,
    		productThumbnail: data.productThumbnail,
    		price: data.price,
    		shippingFee: SHIPPING_FEE,
    		quantity: formData.quantity
		}
		navigate('/order', { state: { orderItems: [orderData] } })
	};

	const data = props.data ? props.data : null;
	const singlePrice = data.price;

  	return (
		<Wrapper>
			<TitleWrapper>
				{ data.bestProduct && <BestFlag size='large'/>}
				<Text size="32px">{data.productName}</Text>
			</TitleWrapper>
			<Price>
				<BoldText size="28px">{data.price.toLocaleString()}원</BoldText>
			</Price>
			<ExtraInfo>
				<BoldText size="18px" color={ FONT.deep01 }>수량</BoldText>
				<Text size="18px" color={ FONT.deep01 }>{data.packingUnit}개입(1박스)</Text>
				<BoldText size="18px" color={ FONT.deep01 }>배송비</BoldText>
				<Text size="18px" color={ FONT.deep01 }>{SHIPPING_FEE.toLocaleString()}원(박스 당)</Text>
			</ExtraInfo>
			<CounterWrapper>
				<Text size="18px">{data.productName}</Text>
				<Counter isActive={ true }
					count={ formData.quantity }
					onCountUp={ onCountUp } onCountDown={ onCountDown } setCountAs={ setCountAs }
				/>
			</CounterWrapper>
			<TotalPriceWrapper>
				<Text size="20px">총 상품 금액</Text>
				<BoldText size="20px">{((singlePrice + SHIPPING_FEE ) * formData.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원</BoldText>
			</TotalPriceWrapper>
			<Buttons height={ "60px" }
				button={[ {
							text: "장바구니",
							onClick: onClickAddToCart
						}, {
							text: "바로구매",
							onClick: onClickBuyNow
						}
					]
				}
			/>
		</Wrapper>
  	);
}